import { ILegalViewService } from "../service/LegalViewService";

export default class ArchiveLegalViewInteractor {
  private legalViewService: ILegalViewService;

  constructor({ legalViewService }: any) {
    this.legalViewService = legalViewService;
  }

  async execute(legalViewId: number) {
    return this.legalViewService.archiveLegalView(legalViewId);
  }
}
